import React from 'react';
import ContactUsImg from '../../Assets/images/ContactUsImage.png';
import SendContact from './SendContact';
import Contact from './Contact';
import MakesLoanContact from './MakesLoanContact';
const ContactUs = () => {
  const handleSmoothScroll = e => {
    e.preventDefault(); // Prevent default anchor link behavior
    const targetId = e.currentTarget.getAttribute('href').substring(1); // Get the target ID without '#'
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Custom smooth scroll logic
      const duration = 1500; // Time in milliseconds for slower scrolling (1.5 seconds)
      const targetPosition = targetElement.getBoundingClientRect().top;
      const startPosition = window.pageYOffset;
      const distance = targetPosition;
      let startTime = null;

      const animation = currentTime => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);

        if (timeElapsed < duration) requestAnimationFrame(animation);
      };

      const ease = (t, b, c, d) => {
        // Easing function for smooth effect (easeInOutQuad)
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };

      requestAnimationFrame(animation);
    }
  };
  return (
    <>
      <div id="contactUs" className="w-full bg-white mt-20 ">
        <div className="container mx-auto -mb-0 md:px-0 px-4 lg:py-16 py-20 flex flex-col lg:flex-row items-center justify-between ">
          {/* Left Section: Text and Button */}
          <div className="text-center lg:text-left lg:w-1/3 mb-4 md:ml-16 lg:mb-0">
            <h1 className="text-2xl 2xl:text-5xl md:text-4xl font-bold text-gray-800 md:mb-4 mb-1 heading">
              Get in Touch with Us
            </h1>
            <p className="text-gray-600 md:text-sm text-xs md:mb-8 mb-4 paragraph">
              We’re here to assist you with any questions or concerns. Whether
              you need support with your loan application or have inquiries
              about our services, feel free to reach out. Our team is dedicated
              to providing prompt and helpful responses to ensure your needs are
              met.
            </p>
            <a
              onClick={handleSmoothScroll}
              href="#sendContact"
              className=" text-headerBtn md:px-6 px-4 md:py-3 py-1 rounded-2xl border-2 border-headerBtn hover:bg-headerBtn hover:text-gray-50 button-text "
            >
              Learn More
            </a>
          </div>

          {/* Right Section: Image */}
          <div className="lg:w-1/2">
            <img
              src={ContactUsImg}
              alt="ContactUsImg"
              className="md:w-11/12 2xl:w-full w-full h-auto"
            />
          </div>
        </div>

        {/* <SendContact /> */}
        <MakesLoanContact/>
      </div>
      <Contact />
    </>
  );
};

export default ContactUs;
